export const errorSnackBar = () => ({
  key: new Date().getTime() + Math.random(),
  options: {
    variant: 'error',
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center',
    },
    // @todo Убрано, так как не работает
    // action: <Button size="small">Скрыть</Button>,
  },
});

export const messageSnackBar = () => ({
  key: new Date().getTime() + Math.random(),
  options: {
    variant: 'info',
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center',
    },
    // @todo Убрано, так как не работает
    // action: <Button size="small">Скрыть</Button>,
  },
});

export const customSnackBar = (params: {
  message: string;
  variant?: string;
  vertical?: string;
  horizontal?: string;
}) => ({
  key: new Date().getTime() + Math.random(),
  message: params.message || 'Создан новый резерв',
  options: {
    variant: params.variant || 'info',
    anchorOrigin: {
      vertical: params.vertical || 'top',
      horizontal: params.horizontal || 'right',
    },
    // Убрано, как в errorSnackBar/messageSnackBar — action с React-элементом приводил к ошибкам
    // action: <Button size="small">Скрыть</Button>,
  },
});
